import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorHeader: {
		id: 'servicedesk-reports-common.table.error.error-header',
		defaultMessage: "Couldn't fetch results",
		description:
			'Generic error message shown when there was an error searching for kb requests reports.',
	},
	errorDescription: {
		id: 'servicedesk-reports-common.table.error.error-description',
		defaultMessage:
			'There was a problem while communicating with the server. Please try again later.',
		description:
			'Generic error message shown when there was an error searching for kb requests reports.',
	},
});
